import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Home = () => {
  const services = [
    {
      title: "DevOps & Cloud Automation",
      text: "Streamlined deployment, CI/CD pipelines, and cloud automation to optimize operations and enhance efficiency.",
      img: "/images/Devops.jpg",
      link: "/devops",
    },
    {
      title: "Full-Stack MERN Development",
      text: "Modern web applications using MongoDB, Express, React, and Node.js (MERN stack) for scalable and secure solutions.",
      img: "/images/mern.jpg",
      link: "/fullstack",
    },
    {
      title: "Automation Testing",
      text: "Learn end-to-end test automation with Selenium, Playwright, API testing, BDD frameworks, and CI/CD quality pipelines.",
      img: "/images/qa.jpg",
      link: "/automation-testing",
    },
    {
      title: "Job Assistance",
      text: "We provide guidance, interview preparation, and real-world project support to help you land your dream job.",
      img: "/images/job.png",
      link: "/job-assistance",
    },
  ];

  const highlights = [
    {
      title: "Industry-focused learning",
      text: "Hands-on programs built around current technologies and real market expectations.",
    },
    {
      title: "Career support",
      text: "Resume guidance, mock interviews, and practical mentorship from day one.",
    },
    {
      title: "Project-first approach",
      text: "Work on real-world scenarios that build confidence and job-ready experience.",
    },
  ];

  const stats = [
    { value: "100%", label: "Practical training" },
    { value: "1:1", label: "Mentor support" },
    { value: "24/7", label: "Learning access" },
  ];

  return (
    <Container fluid className="p-0 home-page">
      <section
        className="hero-shell"
        style={{
          backgroundImage: `linear-gradient(110deg, rgba(15, 23, 42, 0.88), rgba(13, 56, 91, 0.62)), url(${process.env.PUBLIC_URL}/images/bg1.jpg)`,
        }}
      >
        <div className="hero-overlay" />

        <Container className="hero-content">
          <Row className="align-items-center min-vh-70 py-5">
            <Col lg={7} className="hero-copy">
              <span className="eyebrow">Future-ready learning</span>
              <h1>Build Skills That Launch Careers.</h1>
              <p>
                At SPARKLOGIC, we empower you to become a skilled professional in
                DevOps, cloud automation, full-stack MERN development, and
                Automation Testing. Learn to build secure products, automate
                deployments, write reliable test automation, and gain practical
                experience that employers value.
              </p>

              <div className="d-flex flex-wrap gap-3 hero-actions">
                <Button as={Link} to="/register" className="hero-btn primary-btn">
                  Get Started
                </Button>
                <Button as={Link} to="/services" className="hero-btn secondary-btn">
                  Explore Courses
                </Button>
              </div>

              <div className="hero-stats d-flex flex-wrap gap-3 mt-4">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-box">
                    <strong>{stat.value}</strong>
                    <span>{stat.label}</span>
                  </div>
                ))}
              </div>
            </Col>

            <Col lg={5} className="d-none d-lg-block">
              <div className="hero-panel">
                <div className="panel-badge">Career Growth</div>
                <h3>Train for the next big opportunity</h3>
                <ul>
                  <li>Live projects and guided labs</li>
                  <li>Interview preparation support</li>
                  <li>Career guidance from experts</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="feature-section py-5">
        <Container>
          <div className="section-heading text-center mb-4">
            <span className="eyebrow dark">Why learners choose us</span>
            <h2>Career-focused learning designed for real outcomes</h2>
          </div>

          <Row className="g-4">
            {highlights.map((feature, index) => (
              <Col key={index} xs={12} md={4}>
                <div className="feature-card h-100">
                  <div className="feature-icon">0{index + 1}</div>
                  <h4>{feature.title}</h4>
                  <p>{feature.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="services-section pb-5">
        <Container>
          <div className="section-heading text-center mb-4">
            <span className="eyebrow dark">Our expertise</span>
            <h2>Learn the skills that move careers forward</h2>
          </div>

          <Row className="g-4">
            {services.map((service, index) => (
              <Col key={index} xs={12} sm={6} md={4}>
                <Card className="service-card h-100 border-0">
                  <div className="service-image-wrap">
                    <Card.Img variant="top" src={service.img} alt={service.title} />
                  </div>
                  <Card.Body className="text-center">
                    <Card.Title>{service.title}</Card.Title>
                    <Card.Text>{service.text}</Card.Text>
                    <Button as={Link} to={service.link} className="service-btn">
                      Learn More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </Container>
  );
};

export default Home;